'use client';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import Hamburger from '@/shared/ui/icon/Hamburger';
import { useAuth } from '@/shared/providers/AuthProvider';
import GeneralMobileSidebar from '@/shared/ui/layout/header/GeneralMobileSidebar';
import UserMenuButton from '@/shared/ui/layout/header/UserMenuButton';

const GeneralHeader = () => {
  const { user } = useAuth();
  const [showMobileSidebar, setShowMobileSidebar] = useState<boolean>(false);
  const t = useTranslations('Header');

  return (
    <>
      <header className="absolute top-0 z-[100] flex w-full justify-center bg-white/80 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.07)] backdrop-blur-sm">
        <div
          className={
            'max-w-base tablet:h-[30px] main:h-[70px] flex h-[34px] w-full items-center justify-between px-[20px]'
          }
        >
          <div className={'shrink'}>
            <Link href={'/'}>
              <img
                className={'main:h-[22px] h-[13px] w-auto'}
                src={
                  'https://cdn.winging.app/static/builder/icons/winging-logotype-original.png'
                }
                alt={'Winging service logo'}
              ></img>
            </Link>
          </div>
          <div
            className={
              'main:flex hidden items-center justify-between gap-[76px]'
            }
          >
            <Link
              href={'/'}
              className={'text-body2 whitespace-nowrap text-gray-800'}
            >
              {t('서비스 소개')}
            </Link>
            <Link
              href={'/pricing'}
              className={'text-body2 whitespace-nowrap text-gray-800'}
            >
              {t('가격 정책')}
            </Link>
            {!!user && (
              <>
                <Link
                  href={'/dashboard'}
                  className={'text-body2 whitespace-nowrap text-gray-800'}
                >
                  {t('대시보드')}
                </Link>
                <UserMenuButton />
              </>
            )}
            {!user && (
              <>
                <Link
                  href={'/auth/sign-in'}
                  className={'text-body2 whitespace-nowrap text-gray-800'}
                >
                  {t('로그인')}
                </Link>
                <Link
                  href={'/auth/sign-in'}
                  className={
                    'bg-primary flex h-[50px] w-[212px] min-w-[212px] items-center justify-center rounded-md text-[16px] font-bold text-white'
                  }
                >
                  {t('지금 바로 시작하기')}
                </Link>
              </>
            )}
          </div>
          <div className={'main:hidden flex h-full items-center'}>
            <button
              aria-label={showMobileSidebar ? '메뉴 닫기' : '메뉴 열기'}
              aria-expanded={showMobileSidebar}
              className={'text-[#0F172A]'}
              onClick={() => setShowMobileSidebar(!showMobileSidebar)}
            >
              <Hamburger />
            </button>
          </div>
        </div>
      </header>

      {showMobileSidebar && (
        <GeneralMobileSidebar
          showMobileSidebar={showMobileSidebar}
          setShowMobileSidebar={setShowMobileSidebar}
        />
      )}
    </>
  );
};

export default GeneralHeader;
